import { AsyncModule } from 'vuex-async-mutations';

import { InstallationState } from './index';

import { actionsAsync } from './meter.actions';
import { mutationsAsync } from './meter.mutations';

export default {
  actionsAsync,
  mutationsAsync,
} as AsyncModule<InstallationState, any>;
